import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, EMPTY, Observable, of } from 'rxjs';
import { UserReport, UserService } from 'src/app/core';

@Injectable({
  providedIn: 'root',
})
export class UserReportResolver  {
  constructor(private userService: UserService, private router: Router) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<UserReport> {
    return this.userService.getUserSelfReport().pipe(
      catchError(() => {
        this.router;

        this.router.navigate([''], {
          queryParams: {
            authBox: true,
          },
        });
        return EMPTY;
      })
    );
  }
}
